import routeNames from "../router/route-names";
export default {
  DEFAULT_SCREEN: {
    name: routeNames.WALLET,
    path: "/",
  },
  GENDERS: ["MALE", "FEMALE"],
  PAYMENT_METHODS: {
    PAYLANDS: {
      name: "Card",
      key: "PAYLANDS",
    },
    MERCADOPAGO: {
      name: "Mercado Pago",
      key: "MERCADOPAGO",
    },
    MIT: {
      name: "Centro de pagos MIT",
      key: "MIT",
    },
  },
  SIGN_UP_FIELDS: {
    locator: {
      locator: null,
      email: null,
    },
    tag: {
      tag: null,
      email: null,
    },
    no_reference: {
      email: null,
    },
  },
};
